import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import PlanServices from './services/PlanServices';
import { AuthContext } from './AuthContext';

const PrivateRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(null);

  useEffect(() => {
    const checkSubscription = async () => {
    //   console.log('Checking subscription for user:', user);

      if (!user) {
        console.warn('User not found in context');
        setHasActiveSubscription(false);
        return;
      }

      try {
        const token = localStorage.getItem('token');
        // console.log('Token from localStorage:', token);

        if (!token) {
          console.warn('Token not found in localStorage');
          setHasActiveSubscription(false);
          return;
        }

        const response = await PlanServices.getActiveSubscription({
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // console.log('Subscription API response:', response);

        const subscription = response.data;
        // console.log('Extracted subscription:', subscription);

        if (
          subscription &&
          new Date(subscription.endDate) > new Date()
        ) {
        //   console.log('User has an active subscription');
          setHasActiveSubscription(true);
        } else {
          console.warn('User does not have an active subscription');
          setHasActiveSubscription(false);
        }
      } catch (error) {
        console.error('Error checking subscription:', error);
        setHasActiveSubscription(false);
      }
    };

    checkSubscription();
  }, [user]);

  if (hasActiveSubscription === null) {
    console.log('Checking subscription... still loading.');
    return <div>Loading...</div>;
  }

//   console.log('Final check result - hasActiveSubscription:', hasActiveSubscription);

  return hasActiveSubscription ? children : <Navigate to="/pricing" />;
};

export default PrivateRoute;
